import {
  showToast,
  showSuccessToast,
  showFailToast,
  showConfirmDialog,
  showNotify,
} from 'vant'

/** 兼容原 naive-ui 的全局反馈 API */
export function setupFeedback() {
  window.$message = {
    error: (msg) => showFailToast(typeof msg === 'string' ? msg : '操作失败'),
    success: (msg) => showSuccessToast(typeof msg === 'string' ? msg : '操作成功'),
    warning: (msg) => showToast(typeof msg === 'string' ? msg : '提示'),
    info: (msg) => showToast(typeof msg === 'string' ? msg : '提示'),
  }

  window.$dialog = {
    warning: ({
      title = '提示',
      content = '',
      positiveText = '确定',
      negativeText = '取消',
      confirmButtonColor = '#ee0a24',
      onPositiveClick,
      onNegativeClick,
    }) => {
      showConfirmDialog({
        title,
        message: content,
        confirmButtonText: positiveText,
        cancelButtonText: negativeText,
        confirmButtonColor,
      })
        .then(() => onPositiveClick?.())
        .catch(() => onNegativeClick?.())
    },
  }

  window.$notification = {
    info: ({ title = '', content = '' }) => {
      showNotify({ type: 'primary', message: title || content })
    },
    success: ({ title = '', content = '' }) => {
      showNotify({ type: 'success', message: title || content })
    },
    warning: ({ title = '', content = '' }) => {
      showNotify({ type: 'warning', message: title || content })
    },
    error: ({ title = '', content = '' }) => {
      showNotify({ type: 'danger', message: title || content })
    },
  }
}
